import { useEffect, useState } from "react";
import { fetchNewsletterPosts, type NewsletterPost } from "@/lib/cms-newsletter";

export function useNewsletterPosts() {
  const [posts, setPosts] = useState<NewsletterPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetchNewsletterPosts(30)
      .then((data) => {
        if (cancelled) return;
        setPosts(data);
        setError(null);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : "Could not load posts.");
        setPosts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { posts, loading, error };
}